

























































































































































































import { PageBase } from "@/core/models/shared";
import { AutenticadorService } from "@/core/services/shared";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class MasterPage extends PageBase {
    @Prop() private icone!: string;
    @Prop() private titulo!: string;
    @Prop() private subtitulo!: string;

    drawer: boolean = false;
    temaEscuro: boolean = false;
    dialogAlterarSenha: boolean = false;

    geralMenuButtons: any[] = [];
    avaliacaoMenuButtons: any[] = [];
    prestacaoContasMenuButtons: any[] = [];
    monitoramentoMenuButtons: any[] = [];
    auxiliarMenuButtons: any[] = [];
    projetoMenuButtons: any[] = [];
    relatorioMenuButtons: any[] = [];

    mounted() {
        this.$vuetify.theme.dark = this.app.temaEscuro;
        this.Menu();
    }

    Menu(){
        this.geralMenuButtons = [
            { name:'Edital', icon:'mdi-bulletin-board', path:'/edital', restrito: this.Restricao([1]) },
            { name:'Relação Documento (Edital)', icon:'mdi-file-document-multiple-outline', path:'/edital/tipodocumento', restrito: this.Restricao([1]) },
            { name:'Área Atuação', icon:'mdi-chart-line-variant', path:'/edital/areaatuacao', restrito: this.Restricao([1]) },
            { name:'Empresas Grupo', icon:'mdi-domain', path:'/edital/empresagrupo', restrito: this.Restricao([1]) },
            { name:'Natureza Orçamentária', icon:'mdi-file-tree', path:'/edital/natureza', restrito: this.Restricao([1]) },
            { name:'Bairro/Comunidades', icon:'mdi-earth-box', path:'/edital/bairrocomunidade', restrito: this.Restricao([1]) },
            { name:'Critério Avaliação', icon:'mdi-text-box-edit-outline', path:'/edital/criterio', restrito: this.Restricao([1]) }
        ];

        this.avaliacaoMenuButtons = [
            { name:'Avaliar Projeto', icon:'mdi-text-box-edit-outline', path:'/projeto', restrito: this.Restricao([1,2]) },
            { name:'Aprovação', icon:'mdi-text-box-check-outline', path:'/projeto/aprovacao', restrito: this.Restricao([1]) },
            { name:'Consulta', icon:'mdi-text-box-search-outline', path:'/projeto/avaliacao', restrito: this.Restricao([1, 2]) }
        ];

        this.prestacaoContasMenuButtons = [
            { name:'Projeto Analítico', icon:'mdi-chart-areaspline-variant', path:'/relatorio/projetoanalitico', restrito: this.Restricao([1]) },
            { name:'Acompanhamento Financeiro', icon:'mdi-cash-fast', path:'/relatorio/acompanhamentofinanceiro', restrito: this.Restricao([1]) },
            { name:'Fluxo Bancário', icon:'mdi-bank', path:'/relatorio/fluxobancario', restrito: this.Restricao([1]) },
            { name:'Desembolso', icon:'mdi-cash-refund', path:'/relatorio/desembolso', restrito: this.Restricao([1]) }
        ];

        this.monitoramentoMenuButtons = [
            { name:'Indicador', icon:'mdi-calendar-cursor', path:'/relatorio/indicador', restrito: this.Restricao([1]) }
        ];

        this.auxiliarMenuButtons = [
            { name:'Usuário', icon:'mdi-account', path:'/auxiliar/usuario', restrito: this.Restricao([1]) },
            { name:'Empresa', icon:'mdi-factory', path:'/auxiliar/empresa', restrito: this.Restricao([1]) }
        ];

        this.projetoMenuButtons = [
            { name:'Projeto', icon:'mdi-chart-areaspline-variant', path:'/ong/projeto', restrito: this.Restricao([]) }
        ];
    }

    GetAppVersion(){
        const pack = require('../../../package.json');
        return pack.version;
    }

    Restricao(perfilId: number[]){
        if(perfilId.length > 0)
        {
            if(perfilId.find(x => x == this.app.perfilId))
                return true;
            else   
                return false;
        }
        else{
            return true;
        }
    }

    MudarTema(){        
        new AutenticadorService().MudarTema(this.app.usuarioId).then(
            res => super.MudarTema(res.data),
            err => this.$swal('Aviso', err.message, 'error')
        );
    };

    Logout() {
        localStorage.clear();
        this.$vuetify.theme.dark = false;
        this.$router.push({name: 'Login'});
    }
}
